<template>
    <CModal
        title="Редактирование блюда"
        :show.sync="modal.visible"
        :footer="false"
        class="order-fd-item-edit"
    >
        <template>
            <div slot="body-wrapper" class="modal-body">
                <CForm v-if="modal.item">
                    <CRow
                        v-if="florists"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Магазин</CCol>
                        <CCol sm="9">
                            <template v-if="modal.item.florist && modal.item.florist.id">
                                <span class="order-fd-item-edit__title">{{ modal.item.florist.title }}</span>
                            </template>
                            <template v-else>
                                <CSelect
                                    class="mb-0"
                                    inline
                                    :value="null"
                                    :options="florists"
                                    placeholder="Выберите магазин..."
                                    @update:value="updateFlorist"
                                />
                            </template>
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.florist && modal.item.florist.id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Букет</CCol>
                        <CCol sm="9">
                            <template v-if="modal.item.bouquet && modal.item.bouquet.id">
                                <span class="order-fd-item-edit__title">{{ modal.item.bouquet.title }}</span>
                            </template>
                            <template v-else>
                                <Autocomplete
                                    ref="autocomplete"
                                    placeholder="Введите ID или часть названия"
                                    :search="getFloristBouquets"
                                    :get-result-value="getResultValue"
                                    @submit="updateBouquet"
                                />
                            </template>
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.bouquet && modal.item.bouquet.id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Цена букета</CCol>
                        <CCol sm="9" class="col-form-label">
                            {{ +modal.item.bouquet.price }} р.
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.bouquet && modal.item.bouquet.id && options && options.length"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="12"
                            class="col-form-label">Виды</CCol>
                        <template v-for="option in options">
                            <CCol :key="option.id" sm="6">
                                <CInputRadio
                                    class="mb-0"
                                    inline
                                    name="option"
                                    :value="option.id"
                                    :checked="selectedOption === option.id"
                                    @update:checked="updateOptions"
                                />{{ option.title }} - {{ option.price }} р.
                            </CCol>
                        </template>
                    </CRow>
                    <CRow
                        v-if="modal.item.bouquet && modal.item.bouquet.id && extras && extras.length"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="12"
                            class="col-form-label">Дополнительно</CCol>
                        <template v-for="extra in extras">
                            <CCol :key="extra.id" sm="6">
                                <CInputCheckbox
                                    class="mb-0"
                                    inline
                                    :value="extra.id"
                                    :checked="selectedExtras.indexOf(extra.id) >= 0"
                                    @update:checked="updateExtras"
                                />{{ extra.title }} - {{ extra.price }} р.
                            </CCol>
                        </template>
                    </CRow>
                    <CRow
                        v-if="modal.item.bouquet && modal.item.bouquet.id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Цена позиции</CCol>
                        <CCol sm="9">
                            <CInput
                                v-model="modal.item.price"
                                placeholder="Цена позиции"
                            />
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.bouquet && modal.item.bouquet.id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Количество</CCol>
                        <CCol sm="9">
                            <CInput
                                v-model="modal.item.quantity"
                                placeholder="Количество"
                            />
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="modal.item.bouquet && modal.item.bouquet.id"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Возврат</CCol>
                        <CCol sm="9">
                            <CSelect
                                inline
                                :value="modal.item.refund_for"
                                :options="refund_for"
                                placeholder="За счет..."
                                @update:value="updateRefund"
                            />
                        </CCol>
                        <CCol
                            v-if="modal.item.refund_for"
                            tag="label"
                            sm="3"
                            class="col-form-label">Комментарий</CCol>
                        <CCol v-if="modal.item.refund_for" sm="9">
                            <CInput
                                v-model="modal.item.refund_comment"
                                placeholder="Комментарий"
                            />
                        </CCol>
                        <CCol
                            v-if="modal.item.refund_for"
                            tag="label"
                            sm="3"
                            class="col-form-label">Сумма возврата</CCol>
                        <CCol v-if="modal.item.refund_for" sm="9">
                            <CInput
                                v-model.number="modal.item.refund_sum"
                                :placeholder="modal.item.refund_sum ? modal.item.refund_sum : modal.item.price * modal.item.quantity"
                            />
                        </CCol>
                    </CRow>
                </CForm>
            </div>
            <div slot="footer">
                <CButton
                    color="light"
                    class="ml-3"
                    @click="$emit('cancel')"
                >Отмена</CButton>
                <CButton
                    color="primary"
                    class="ml-3"
                    :disabled="!(modal.item.bouquet && modal.item.bouquet.id)"
                    @click="$emit('update')"
                >Сохранить</CButton>
            </div>
        </template>
    </CModal>
</template>

<script>
    import Vue from 'vue';
    const { formatDate } = require('../../utils/views');
    import Autocomplete from '@trevoreyre/autocomplete-vue';
    import '@trevoreyre/autocomplete-vue/dist/style.css';

    export default {
        name: 'OrderFDItemEdit',

        components: {
            Autocomplete,
        },

        props: {
            modal: {
                type: Object,
                default: () => ({})
            }
        },

        data() {
            return {
                isAuthorized: false,
                florists: null,
                bouquets: null,
                options: null,
                extras: null,
                refund_for: [{
                    value: 'МИРСИТИ',
                    label: 'МИРСИТИ'
                },{
                    value: 'Партнера',
                    label: 'Партнера'
                }],
            };
        },

        computed: {
            visible() {
                return this.modal.visible
            },
            selectedOption() {
                return this.modal.item.options && this.modal.item.options.length ? this.modal.item.options[0].id : null;
            },
            selectedExtras() {
                return this.modal.item.extras.map(i => {
                    return i.id
                });
            },
        },

        watch: {
            visible: async function (val) {
                if(!this.florists) {
                    try {
                        const { data } = await Vue.axios.get('/florists');
                        data.sort((a, b) => a.title > b.title ? 1 : -1);
                        this.florists = data.map(florist => {
                            return {
                                value: florist.id,
                                label: florist.title
                            }
                        });
                    } catch(err) {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    }
                }
                this.bouquets = null;

                if(!this.modal.item.quantity) {
                    this.modal.item.quantity = 1
                }

                if(this.modal.item.florist && this.modal.item.florist.id && this.modal.item.bouquet && this.modal.item.bouquet.id) {
                    await this.getBouquetOptions(this.modal.item.florist.id, this.modal.item.bouquet.id);
                    await this.getBouquetExtras(this.modal.item.florist.id, this.modal.item.bouquet.id);
                }
            },
            modal: {
                deep: true,
                handler() {
                    if (this?.modal?.item?.refund_for
                        && !this?.modal?.item?.refund_sum
                        && this?.modal?.item?.refund_sum !== 0
                    && this?.modal?.item?.refund_sum !== '') {
                        this.modal.item.refund_sum = this.modal.item.price * this.modal.item.quantity;
                    }
                }
            }
        },

        mounted() {

        },

        methods: {
            formatDate(date) {
                return formatDate(date);
            },
            getResultValue(result) {
                return result.title;
            },
            async getFloristBouquets(search) {
                return new Promise(resolve => {
                    if (search.length < 2) {
                        return resolve([]);
                    }

                    Vue.axios
                        .get(`/florists/${ this.modal.item.florist.id }/bouquets?search=${ search }`, {})
                        .then(resp => {
                            resolve(resp.data.results);
                        })
                        .catch(err => {
                            console.log('Cannot load goods list.');
                        });
                });
            },
            async getBouquetOptions(floristId, bouquetId) {
                try {
                    const { data } = await Vue.axios.get(`/bouquets/${ bouquetId }/bouquet_options`);
                    this.options = data;
                } catch(err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },
            async getBouquetExtras(floristId, bouquetId) {
                try {
                    const { data } = await Vue.axios.get(`/bouquets/${ bouquetId }/bouquet_extras`);
                    this.extras = data;
                } catch(err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },
            async updateFlorist(value) {
                for(let i=0; i < this.florists.length; i++) {
                    if(value === this.florists[i].value) {
                        this.modal.item = {
                            ...JSON.parse(JSON.stringify(this.modal.emptyItem)),
                            ...{
                            id: this.modal.item.id,
                            florist: {
                                id: this.florists[i].value,
                                title: this.florists[i].label
                            }
                        }
                        };
                    }
                }
                await this.getFloristBouquets(this.modal.item.florist.id);
            },
            async updateBouquet(bouquet) {
                this.modal.item = {
                    ...JSON.parse(JSON.stringify(this.modal.emptyItem)),
                    ...{
                    id: this.modal.item.id,
                    florist: {
                        id: this.modal.item.florist.id,
                        title: this.modal.item.florist.title,
                    },
                    bouquet,
                    bouquet_id: bouquet.id,
                    bouquet_title: bouquet.title,
                    bouquet_price: bouquet.price,
                }
                };
                await this.getBouquetOptions(this.modal.item.florist.id, this.modal.item.bouquet.id);
                await this.getBouquetExtras(this.modal.item.florist.id, this.modal.item.bouquet.id);
                this.recalculatePrice();
            },
            updateRefund(refundFor) {
                this.modal.item.refund_for = refundFor;
            },
            updateOptions(checked, obj) {
                for(let i=0; i < this.options.length; i++) {
                    if(+obj.target.value === this.options[i].id) {
                        this.modal.item.options = [{
                            ...this.options[i]
                        }];
                    }
                }
                this.recalculatePrice();
            },
            updateExtras(checked, obj) {
                if(checked) {
                    for(let i=0; i < this.extras.length; i++) {
                        if(+obj.target.value === +this.extras[i].id) {
                            this.modal.item.extras.push(this.extras[i]);
                        }
                    }
                } else {
                    for(let i=0; i < this.modal.item.extras.length; i++) {
                        if(+obj.target.value === +this.modal.item.extras[i].id) {
                            this.modal.item.extras.splice(i, 1);
                        }
                    }
                }
                this.recalculatePrice();
            },
            recalculatePrice() {
                let price = +this.modal.item.bouquet.price;
                for(let i=0; i < this.modal.item.options.length; i++) {
                    price += +this.modal.item.options[i].price;
                }
                for(let i=0; i < this.modal.item.extras.length; i++) {
                    price += +this.modal.item.extras[i].price;
                }
                this.modal.item.price = price;
                console.log(this.modal.item);
            }
        },
    };
</script>

<style lang="scss">
    .order-fd-item-edit {
        &__title {
            display: flex;
            align-items: center;
            width: 100%;
            height: calc(1.5em + 0.75rem + 2px);
        }
        .autocomplete-input {
            width: 100%;
            height: calc(1.5em + 0.75rem + 2px);
            border: 1px solid #d8dbe0;
            border-radius: 0.25rem;
            padding: 0.375rem 0.75rem 0.375rem 2rem;
            background-color: #fff;
            background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjY2IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+);
            background-size: 0.875rem;
            background-position: left 0.75rem center;
            background-repeat: no-repeat;
            color: #768192;
            font-size: 0.875rem;
            font-weight: 400;
            line-height: 1.5;
        }
        .autocomplete-result {
            cursor: default;
            padding: 0.375rem 0.75rem 0.375rem 2rem;
            background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjY2NjIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+);
            background-size: 15px;
            background-position: left 0.75rem center;
            background-repeat: no-repeat;
            color: #768192;
            font-size: 0.875rem;
            font-weight: 400;
            line-height: 1.1;
        }
    }
</style>
